class UserSettingsConfig {
    public LastSignatureResizePixels: number;
    public ShowDocumentInAppView?: boolean;
    public HideAutoApproveWarningPopup?: boolean;

    constructor(fields: Partial<UserSettingsConfig>) {
        Object.assign(this, fields);
    }
}

export { UserSettingsConfig };
